<template>
<v-container class="movement-focus">
    <v-row v-if="!isMobile">
        <v-col v-for="(item, i) in countries" :key="i" :class="i < 2 ? 'sideBorder mr-3' : 'sideBorderHidden mr-3'">
            <v-row class='mb-0 pb-0 pl-3'>
                    <h5 class="countryName pr-2">{{ item.country_name }}</h5>
                    <movement-widget :countryObject="item" />
                    <v-icon v-if="i == countries.length -1" v-tooltip="tooltip" class="pl-2 movement-tooltip">mdi-information-outline</v-icon>
            </v-row>
            <v-row class="mt-0 pt-0">
                <v-col md="12" cols="12">
                    <p class="mainText pl-0 ml0">{{ item.riskData[0].description }}</p>
                </v-col>
            </v-row>
            <v-row class="">
                <v-col>
                    <explore-button class="" @click="selectCountry(item)" />
                </v-col>
            </v-row>
        </v-col>
    </v-row>

    <v-row v-if="isMobile">
        <v-carousel v-model="currentPage" hide-delimiters show-arrows-on-hover  class="movement-focus-carousel" height="345px">
            <v-carousel-item v-for="(item, i) in countries" :key="i" class="pa-0 ma-0">
                <v-row class="">
                    <v-col md="8" cols="12" class="countryName">
                        <h5>{{ item.country_name }}</h5>
                        <movement-widget class="movement-widget-component ml-3" :countryObject="item" />

                        <v-tooltip open-on-click width="90%" :text=tooltip class="lineItem movementInfoIcon" v-if="i == countries.length -1">
                            <template v-slot:activator="{ props }">
                                <v-img v-bind="props" :src="require('@/assets/icons/atradius-info.svg')" class="info-icon" />
                            </template>
                        </v-tooltip>
                    </v-col>
                    
                   
                </v-row>
                <v-row class="">
                    <v-col md="3" cols="12">
                        <p class="mainText">{{ item.riskData[0].description }}</p>
                    </v-col>
                </v-row>
                <v-row class="">
                    <v-col>
                        <explore-button @click="selectCountry(item)" 
                            class="mobileExploreButton"
                        />
                    </v-col>
                </v-row>
            </v-carousel-item>
        </v-carousel>

        <v-row justify="center" class="mt-3 ml-3">
            <v-col md="12" cols="12">
                <v-row>
                    <v-col md="8" cols="8">
                        <v-for class="pagination-bars">
                            <v-col v-for="(item, index) in countries" :key="index" :class="{ 'active-bar': index === currentPage }" class="pagination-bar">
                                <span  @click="goTo(index)"></span>
                            </v-col>
                        </v-for>
                    </v-col>
                    <v-col>
                        <v-btn icon @click="prev" class="paginationArrow paginationArrowPrev" variant="text" :rounded="'rounded'" density="compact" :disabled="!prevEnabled">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-btn icon @click="next" class="paginationArrow paginationArrowNext" variant="text" :rounded="'rounded'" density="compact" :disabled="!nextEnabled">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

            </v-col>
        </v-row>

    </v-row>
</v-container>
</template>

<script lang="ts">
import {
    defineComponent
} from 'vue';
import store from '@/store';
import {
    Service as CountryService
} from '@/services/countryService';

export default defineComponent({
    name: 'MovementFocus',
    data() {
        return {
            isMobile: window.innerWidth <= 900,
            countries: [] as any[],
            currentPage: 0,
            tooltip: "The arrow indicates movement up/down and by what amount out of 10.",
            prevEnabled: false,
            nextEnabled: true
        };
    },
    mounted() {
        this.loadCountries();
        
    },
    methods: {
        prepareTooltip() {
            // // get the last country in the list
            
            // const lastCountry = this.countries[this.countries.length - 1];
            // console.log('lastCountry', lastCountry);
            // // country.riskData[0].difference
            // const movement = lastCountry.riskData[0].difference;
            // let result = "The arrow indicates movement up/down and by what amount out of 10.";
            
            // console.log('movement', movement);

            // if(movement != 0){
            //     this.tooltip = "Arrow down is a downgrade; arrow up an upgrade - and by what amount out of 10. Change since Q1 of 2024.";
            // }else{
            //     this.tooltip = '“0” means no movement up/down out of 10 - since Q1 of 2024';
            // }

            const tooltipData = store.getters['displayStoreData/toolTipData'];
            const lastCountry = this.countries[this.countries.length - 1];

            try {
                if(lastCountry.riskData[0].star_previous_quarter != lastCountry.riskData[0].star && tooltipData ){
                    const tooltipText = tooltipData.movement_focus_modal.different_risk_star_values.text;
                    this.tooltip = tooltipText;
                    return tooltipText;
                }else{
                    const tooltipText = tooltipData.movement_focus_modal.same_risk_star_values.text;
                    this.tooltip = tooltipText;
                    return tooltipText;
                }
                    
            } catch (error) {
                // 
            }

           
            
        },
        selectCountry(country: any) {
            store.dispatch('stateStoreData/setFocusMode', null);
            store.dispatch('stateStoreData/setModalMode', 'data');
            store.dispatch('countryStoreData/setSelectedCountry', country);
        },
        async loadCountries() {
            const allCountriesModule = await import('@/data/allCountryData.json');
            this.findMovementFocusCountries(allCountriesModule.default);
        },
        async findMovementFocusCountries(allCountries: any) {
            this.countries = CountryService.getMovementFocusCountries(3);
            console.log(this.countries)
        },
        prev() {
            this.currentPage =
                this.currentPage === 0 ? this.countries.length - 1 : this.currentPage - 1;
        },
        next() {
            this.currentPage =
                this.currentPage === this.countries.length - 1 ? 0 : this.currentPage + 1;
        },
        goTo(index: number) {
            this.currentPage = index;
        }
    },
    watch: {
        currentPage() {
            if (this.currentPage == 0) {
                this.prevEnabled = false;
                this.nextEnabled = true;
            } else if (this.currentPage == this.countries.length - 1) {
                this.prevEnabled = true;
                this.nextEnabled = false;
            } else {
                this.prevEnabled = true;
                this.nextEnabled = true;
            }
        },
        countries() {
            this.prepareTooltip();
        }
    }
});
</script>

<style>
.info-icon {
    width: 20px;
    height: 20px;
    display: inline-block;
    /* top: 5px; */
    margin-left: 10px;
}
h5 {
    font-family: 'GCO' !important;
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: -2%;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0.2px;
}

.movement-focus p.mainText {
    min-height: 190px;
    display: block;
    color: #606A76;
    line-height: 1.7;
    padding: 0 10px 0 10px;
    font-size: 14px;
}

.sideBorder {
    border-right: 1px solid #d3d3d4;
    padding: 20px 0;
}

.sideBorderHidden {
    padding: 20px 0;
}

.movementDataHolder>div {
    display: inline-block;
    align-items: center;
}

.movementDirectionArrow>.arrow-icon,
.movementDifference {
    font-size: 12px;
    padding: 0px;
    gap: 0px;
    line-height: 0px;
    margin-bottom: 15px;
    top: -5px;
}

.movementDifference {
    top: -11px;
    position: relative;
}

.v-carousel-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
}

.v-card {
    max-width: 400px;
    width: 100%;
}

.pagination-bars {
    display: flex;
    align-items: center;
    padding-top: 25px;
}

.pagination-bar {
    height: 1.5px;
    border:none;
    margin: 0 4px;
    cursor: pointer;
    margin: 0;
    padding: 0;
}

.pagination-bar span{
    display: block;
    height: 1.5px;
    width: 90%;
    background-color: #E7E9EE;

}
.active-bar {
    background: none;
    border: none;
}

.active-bar span{
    background-color: #DC0128;

}



.movement-focus-carousel .v-window__controls {
    display: none;
}

.paginationArrow{
    margin-top: 12px;
    background: none !important;
    box-shadow: none !important;
}

.movement-focus-carousel .sideBorder{
    margin: 0;
    padding: 0;
}
.movement-focus-carousel .mainText{
    font-size: 14px;
}

.movement-focus-carousel h5{
    font-size: 18px;
    display: inline-block;
}

.movement-tooltip {
    font-size: 20px;
    color: #606A76;
    cursor: pointer;
    position: relative;
    /* top: -50%; */
}

.paginationArrowNext {
    position:absolute;
    right: 25px;
}

/* Mobile media query */
@media (max-width: 900px) {

  
    .movement-focus-carousel .movement-widget-component {
        display: inline-block;
    }

   .movementDataHolder{
    display: none;
   }
   
   .movement-focus-carousel{
    /* height: 425px !important; */
    overflow: hidden;
    margin-bottom: -30px;
   }

   .movement-focus{
    padding: 0;
   }

   .mainText{
    padding: 0 !important;
   }

   .movement-focus p.mainText{
        height: 230px;
   }
 
}

/* Desktop */
@media (min-width: 900px) {
    .movement-focus p.mainText{
        min-height: 250px;
    }
}
</style>
